module.exports = __webpack_public_path__ + "static/media/0024_FE_LES_ENSEIGNES_LES_FROMAGES_LETTRE_A_LETTRE.6715c7cf.png";